// utils/validators.js
export const isValidArray = (data) => {
  return Array.isArray(data) && data.length > 0;
};

export const isValidString = (data) => {
  return (
    typeof data === "string" &&
    data.trim() !== "" &&
    !["N/A", "null", "undefined"].includes(data.trim())
  );
};

export const isValidData = (data) => {
  if (data == null) return false;

  if (Array.isArray(data)) return isValidArray(data);

  if (typeof data === "string") return isValidString(data);

  if (typeof data === "object") return Object.keys(data).length > 0;

  return true;
};
